import type { SignalRArgs, SignalRTopic } from '@/api/signalR/messages/signalRtypes.ts';

export type HeartbeatTimeoutMessage = { type: 'heartbeatTimeout'; streamId: string };

/** the worker lost its connection and asks the tabs for a fresh SG Connect token */
export type TokenRequested = { type: 'tokenRequested' };

export type WorkerSentMessage =
  | ConnectionStatusUpdate
  | SignalRMessageReceived
  | HeartbeatTimeoutMessage
  | TokenRequested;

export type Idle = { type: 'statusUpdate'; status: 'idle' };
export type Connecting = { type: 'statusUpdate'; status: 'connecting' };
export type Connected = {
  type: 'statusUpdate';
  status: 'connected';
  connectionId: string;
  isDegraded: boolean;
};
export type Disconnected = {
  type: 'statusUpdate';
  status: 'disconnected';
  reason: string;
  /** true when the worker gave up reconnecting: only a page reload or a fresh token can heal it */
  isFatal?: boolean;
};
export type ConnectionStatusUpdate = Idle | Connecting | Connected | Disconnected;

export type SignalRMessageReceived<T extends SignalRTopic = SignalRTopic> = {
  type: 'signalRMessageReceived';
  topic: T;
  payload: SignalRArgs<T>;
};

export function connectionStatusToString(update: ConnectionStatusUpdate): string {
  switch (update.status) {
    case 'idle': {
      return 'IDLE';
    }
    case 'connecting': {
      return 'CONNECTING';
    }
    case 'disconnected': {
      return `DISCONNECTED (reason: ${update.reason}, isFatal: ${update.isFatal === true})`;
    }
    case 'connected': {
      return `CONNECTED (connectionId: ${update.connectionId}, isDegraded: ${update.isDegraded})`;
    }
  }
}
